ACC.applePay = {
    _autoload: [
        ['bindApplePay', document.getElementById('applePayRadioBtn')],
    ],

    billingAddressForm: {},
    shippingAddressForm: {},
    digitalOrder: true,
    initialShippingAddressId: '',
    initialShippingMethodCode: '',
    applePaySession: null,

    bindApplePay() {
        if (!window.ApplePaySession) { return; }

        if (document.getElementById('pearsonDummyApplePayButton')) {
            document.querySelector('.applePayMethod').removeAttribute('style');
            return;
        }

        const actionBtn = document.getElementById('pearsonApplePayButton');
        if (!actionBtn) { return; }

        actionBtn.addEventListener('click', ACC.applePay.bindApplePayButton);

        document.querySelector('.applePayMethod').removeAttribute('style');

        ACC.applePayHelpers.toggleApplePayButton();
    },

    bindApplePayButton() {
        ACC.applePayHelpers.sendDataLayer();
        const paymentRequest = {};
        $.ajax({
            url: `${ACC.config.encodedContextPath}/applePayOrderInfo/initial`,
            dataType: 'json',
        })
            .then((data) => {
                ACC.applePay.setUpInitialValues(data);

                paymentRequest.countryCode = data.country;
                paymentRequest.currencyCode = data.currency;
                paymentRequest.requiredBillingContactFields = ['postalAddress'];
                paymentRequest.requiredShippingContactFields = ['email', 'phone'];
                paymentRequest.shippingType = 'shipping';
                paymentRequest.supportedNetworks = data.supportedNetworks;
                paymentRequest.merchantCapabilities = ['supports3DS'];

                if (!data.digitalOrder) {
                    ACC.applePay.digitalOrder = false;
                    paymentRequest.requiredShippingContactFields.push('postalAddress');

                    paymentRequest.shippingContact = {
                        givenName: data.deliveryAddress.firstName,
                        familyName: data.deliveryAddress.lastName,
                        addressLines: [data.deliveryAddress.line1],
                        locality: data.deliveryAddress.town,
                        postalCode: data.deliveryAddress.postalCode,
                        countryCode: data.deliveryAddress.country.isocode,
                    };

                    if (data.deliveryAddress.line2) {
                        paymentRequest.shippingContact.addressLines.push(data.deliveryAddress.line2);
                    }

                    if (data.deliveryAddress.region !== null) {
                        paymentRequest.shippingContact.administrativeArea = data.deliveryAddress.region.isocodeShort;
                    }
                    paymentRequest.shippingMethods = data.deliveryMethods;
                }

                ACC.applePayHelpers.populateOrderTotals(paymentRequest, data, 'lineItems', 'total');

                const session = new ApplePaySession(3, paymentRequest);
                ACC.applePay.applePaySession = session;

                ACC.applePay.onCancel(session);

                ACC.applePay.onValidateMerchant(session);

                ACC.applePay.onPaymentMethodSelected(session);

                ACC.applePay.onShippingContactSelected(session);

                ACC.applePay.onPaymentAuthorized(session);

                ACC.applePay.onShippingMethodSelected(session);

                session.begin();
            });
    },

    onCancel(session) {
        session.oncancel = (event) => {
            console.log('apple pay session oncancel called');
            if (!ACC.applePay.digitalOrder) {
                ACC.applePayHelpers.updateShippingMethod(ACC.applePay.initialShippingMethodCode);
                ACC.applePayHelpers.setInitialShippingAddress();
            }
            console.log(event);
        };
    },

    onValidateMerchant(session) {
        session.onvalidatemerchant = (event) => {
            const { validationURL } = event;
            $.ajax(`${ACC.config.encodedContextPath}/applePay/createSession`, {
                method: 'post',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                data: {
                    validationURL,
                    CSRFToken: $('input[name="CSRFTokvalidate merchanten"]').val(),
                },
                dataType: 'text',
            }).then((res) => {
                session.completeMerchantValidation(JSON.parse(res));
            }).catch(() => {
                session.abort();
                ACC.globalmessages.callErrorGlobalMessage('apple.pay.place.order.payment.error');
            });
        };
    },

    onPaymentMethodSelected(session) {
        session.onpaymentmethodselected = (event) => {
            const redactBillingContact = event.paymentMethod.billingContact;
            if (redactBillingContact !== undefined) {
                ACC.applePay.collectRedactBillingAddressForm(redactBillingContact);
                ACC.applePayHelpers.validateBillingAddress()
                    .then(() => ACC.applePay.completePaymentMethodChange(session));
            } else {
                ACC.applePay.completePaymentMethodChange(session);
            }
        };
    },

    onShippingContactSelected(session) {
        session.onshippingcontactselected = ({ shippingContact }) => {
            if (shippingContact !== undefined) {
                ACC.applePay.collectRedactShippingAddressForm(shippingContact);
                ACC.applePay.updateShippingAddress(
                    () => ACC.applePay.completeShippingContactChange(session),
                    (errorMessage) => ACC.applePay.failShippingMethodChange(session, errorMessage),
                );
            } else {
                ACC.applePay.completeShippingContactChange(session);
            }
        };
    },

    onPaymentAuthorized(session) {
        session.onpaymentauthorized = (event) => {
            const paymentBillingContact = event.payment.billingContact;
            const paymentShippingContact = event.payment.shippingContact;
            ACC.applePay.fillBillingAddressForm(paymentBillingContact, paymentShippingContact);
            ACC.applePay.fillShippingAddressForm(paymentShippingContact);
            ACC.applePayHelpers.isInitialShippingAddress()
                .then((isInitial) => {
                    if (!isInitial) {
                        ACC.applePay.updateShippingAddress(
                            () => ACC.applePay.validateBillingAddressAndPlaceOrder(event, session),
                            () => ACC.applePayHelpers.failApplePaySessionWithWrongShippingAddress(session),
                        );
                    } else {
                        ACC.applePay.validateBillingAddressAndPlaceOrder(event, session);
                    }
                });
        };
    },

    validateBillingAddressAndPlaceOrder(event, session) {
        ACC.applePayHelpers.validateBillingAddress()
            .then((response) => {
                if ($(response).find('#isSuccess').val() === 'true') {
                    ACC.applePay.fillFormWithMaskedPaymentCart(event);
                    ACC.secureacceptance.cartValidation(
                        () => ACC.applePay.handleSuccessValidateAddress(event, session),
                        (data) => {
                            session.abort();
                            ACC.applePay.showCartValidationErrorForApplePay(data);
                        },
                        ACC.applePay.billingAddressForm,
                    );
                } else {
                    ACC.applePayHelpers.failApplePaySessionWithWrongBillingAddress(session);
                }
            });
    },

    showCartValidationErrorForApplePay(data) {
        if (!ACC.config.applePayDummyButtonEnabled) {
            ACC.applePayHelpers.failApplePaySession(ACC.applePay.applePaySession);
        }
        ACC.secureacceptance.showCartValidationError(data);
    },
    handleSuccessValidateAddress(event, session) {
        if ($('#updatePaymentSOP').length) {
            ACC.applePay.updatePaymentMethodToApplePay(event, session);
        } else {
            ACC.orderPlaceAdditionalDataProcessor.sendOrderPlaceAdditionalData();
            ACC.applePay.placeApplePayOrder(event, session);
        }
    },

    fillFormWithMaskedPaymentCart(event) {
        const cardName = event.payment.token.paymentMethod.displayName;
        ACC.applePay.billingAddressForm.cartNumberMasked = `************${cardName.substring(cardName.length - 4)}`;
    },

    onShippingMethodSelected(session) {
        session.onshippingmethodselected = ({ shippingMethod }) => {
            ACC.applePayHelpers.updateShippingMethod(shippingMethod.identifier)
                .then(() => ACC.applePay.completeShippingMethodChange(session));
        };
    },

    setUpInitialValues(data) {
        if (data.deliveryAddress !== null) {
            ACC.applePay.initialShippingAddressId = data.deliveryAddress.id;
        }
        if (data.deliveryMethods !== null && data.deliveryMethods.length) {
            ACC.applePay.initialShippingMethodCode = data.deliveryMethods[0].identifier;
        }
    },

    updatePaymentMethodToApplePay(event, session) {
        // eslint-disable-next-line max-len
        $.ajax(`${ACC.config.encodedContextPath}/paymentmethod/updatePaymentMethodToApplePay?subscriptionNumber=${ACC.config.currentSubscriptionNumber}`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                CSRFToken: ACC.config.CSRFToken,
            },
            data: JSON.stringify(event.payment),
            dataType: 'text',
        }).then(() => {
            ACC.applePayHelpers.completeApplePaySession(session);
            window.location = `${ACC.config.encodedContextPath}/account`;
        }).catch(() => {
            ACC.applePayHelpers.failApplePaySession(session);
            ACC.globalmessages.callErrorGlobalMessage('apple.pay.place.order.payment.error');
        });
    },

    placeApplePayOrder(event, session) {
        const io_bb_value = $('#io_blackbox').length ? $('#io_blackbox').val() : '';

        const authorizationData = JSON.parse(JSON.stringify(event.payment));
        authorizationData.deviceId = io_bb_value;

        $.ajax(`${ACC.config.encodedContextPath}/applePay/placeOrder`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                CSRFToken: ACC.config.CSRFToken,
            },
            data: JSON.stringify(authorizationData),
            dataType: 'json',
        }).then((res) => {
            if (res.orderCode && res.decision === 'ACCEPT') {
                ACC.applePayHelpers.completeApplePaySession(session);
                window.location = `${ACC.config.encodedContextPath}/checkout/orderConfirmation/${res.orderCode}`;
            } else {
                ACC.applePayHelpers.failApplePaySession(session);
                window.location = `${ACC.config.encodedContextPath}/checkout/multi/cybs-applePay/payment/error`;
            }
        }).catch((err) => {
            console.log(err);
            ACC.applePayHelpers.failApplePaySession(session);
            window.location = `${ACC.config.encodedContextPath}/checkout/multi/cybs-applePay/payment/error`;
        });
    },

    fillBillingAddressForm(billingContact, shippingContact) {
        if (!billingContact) { return; }

        const form = ACC.applePay.billingAddressForm;
        form.billTo_firstName = billingContact.givenName;
        form.billTo_lastName = billingContact.familyName;
        const billingAddressLines = billingContact.addressLines;
        form.billTo_street1 = billingAddressLines[0] || '';
        form.billTo_street2 = billingAddressLines[1] || '';
        form.billTo_country = billingContact.countryCode;
        form.billTo_city = billingContact.locality;
        form.billTo_postalCode = billingContact.postalCode;
        form.billTo_state = billingContact.administrativeArea;

        if (shippingContact) {
            form.billTo_email = shippingContact.emailAddress || '';
            form.billTo_phoneNumber = shippingContact.phoneNumber || '';
        }
    },

    fillShippingAddressForm(shippingContact) {
        if (ACC.applePay.digitalOrder || !shippingContact) { return; }

        const form = ACC.applePay.shippingAddressForm;
        form.firstName = shippingContact.givenName;
        form.lastName = shippingContact.familyName;
        form.countryIso = shippingContact.countryCode;
        form.townCity = shippingContact.locality;
        form.postcode = shippingContact.postalCode;
        form.regionIso = shippingContact.administrativeArea;
        form.email = shippingContact.emailAddress || '';
        form.phone = shippingContact.phoneNumber || '';
        const shippingAddressLines = shippingContact.addressLines;
        form.line1 = shippingAddressLines[0] || '';
        form.line2 = shippingAddressLines[1] || '';
    },

    collectRedactBillingAddressForm(billingContact) {
        if (!billingContact) { return; }
        const form = ACC.applePay.billingAddressForm;
        form.billTo_country = billingContact.countryCode;
        form.billTo_city = billingContact.locality;
        form.billTo_postalCode = billingContact.postalCode;
        form.billTo_state = billingContact.administrativeArea;
    },

    collectRedactShippingAddressForm(shippingContact) {
        if (!shippingContact) { return; }
        const form = ACC.applePay.shippingAddressForm;
        form.townCity = shippingContact.locality;
        form.regionIso = shippingContact.administrativeArea;
        form.postcode = shippingContact.postalCode;
        form.countryIso = shippingContact.countryCode;
        form.line1 = '';
        form.line2 = '';
    },

    updateShippingAddress(onThenFunction, onFailFunction) {
        if (ACC.applePay.digitalOrder) {
            onThenFunction();
        } else {
            $.ajax(`${ACC.config.encodedContextPath}/applePay/deliveryAddress/update`, {
                method: 'post',
                headers: {
                    CSRFToken: ACC.config.CSRFToken,
                },
                data: ACC.applePay.shippingAddressForm,
                async: false,
            }).then((data) => {
                if (data.isValidAddress) {
                    onThenFunction();
                } else {
                    onFailFunction(data.errorMessage);
                }
            }).catch(({ message }) => {
                console.log(message);
                onFailFunction();
            });
        }
    },

    completePaymentMethodChange(session) {
        ACC.applePayHelpers.requestApplePayOrderInfo()
            .then((data) => {
                const newPaymentTotal = {};
                ACC.applePayHelpers.populateOrderTotals(newPaymentTotal, data, 'newLineItems', 'newTotal');
                session.completePaymentMethodSelection(newPaymentTotal);
            });
    },

    completeShippingContactChange(session) {
        ACC.applePayHelpers.requestApplePayOrderInfo()
            .then((data) => {
                const newPaymentTotal = {};
                ACC.applePayHelpers.populateOrderTotals(newPaymentTotal, data, 'newLineItems', 'newTotal');
                session.completeShippingContactSelection(newPaymentTotal);
            });
    },

    completeShippingMethodChange(session) {
        ACC.applePayHelpers.requestApplePayOrderInfo()
            .then((data) => {
                const newPaymentTotal = {};
                ACC.applePayHelpers.populateOrderTotals(newPaymentTotal, data, 'newLineItems', 'newTotal');
                newPaymentTotal.newShippingMethods = data.deliveryMethods;
                session.completeShippingMethodSelection(newPaymentTotal);
            });
    },

    failShippingMethodChange(session, errorMessage) {
        ACC.applePayHelpers.requestApplePayOrderInfo()
            .then((data) => {
                const newPaymentTotal = {};
                ACC.applePayHelpers.populateOrderTotals(newPaymentTotal, data, 'newLineItems', 'newTotal');
                newPaymentTotal.status = ApplePaySession.STATUS_FAILURE;
                console.log(errorMessage);
                if (errorMessage) {
                    newPaymentTotal.errors = [
                        new ApplePayError('shippingContactInvalid', 'postalAddress', errorMessage),
                    ];
                }
                session.completeShippingContactSelection(newPaymentTotal);
            });
    },
};
